import { graphql } from "@/api/graphql/types/gql.ts";

export const deleteTidLinkedAccountMutation = graphql(`
  mutation DeleteTidLinkedAccount($id: ID!) {
    BillingMsDeleteTidLinkedAccount(request: { id: $id })
  }
`);
